<script>
import { h } from 'vue';
import { Space, Button, Dropdown, Menu, MenuItem } from 'ant-design-vue';
import { DolIcon } from 'dolphin-framework-vue'
import DolButton from '../dolphin-ant-design/common/dol-button.vue'
import { DolIconButton } from '@/components/dolphin-ant-design';

export default {
  name: 'dol-list-button',
  props: {
    buttons: {type: Array, default: () => []},
    column: {type: Object},
    value: {},
    record: {},
    index: {type: Number},
    maxCount: {type: Number, default: 3},
    params: {},
  },
  data () {
    return {
    };
  },
  methods: {},
  render() {
    const props = {column: this.column, value: this.value, record: this.record, index: this.index, params: this.params};

    const renderButtons = this.buttons.filter(buttonConfig => {
      const checkFlag = typeof buttonConfig.check === 'function' ? buttonConfig.check(props) : true;
      const authFlag = buttonConfig.buttonCode ? this.$auth(buttonConfig.buttonCode) : true;
      return checkFlag && authFlag;
    });

    const buttons = [];
    if(renderButtons.length <= this.maxCount){
      renderButtons.forEach(buttonConfig => {
        const disabledFlag = typeof buttonConfig.disabled === 'function' ? buttonConfig.disabled(props) : !!buttonConfig.disabled;
        const buttonProps = {
          title: buttonConfig.title,
          icon: buttonConfig.icon,
          disabled: disabledFlag,
          onClick: () => !disabledFlag && buttonConfig.click(props),
        };
        buttons.push(h(DolIconButton, buttonProps));
      });
    }else{
      renderButtons.slice(0, this.maxCount - 1).forEach(buttonConfig => {
        const disabledFlag = typeof buttonConfig.disabled === 'function' ? buttonConfig.disabled(props) : !!buttonConfig.disabled;
        const buttonProps = {
          title: buttonConfig.title,
          icon: buttonConfig.icon,
          disabled: disabledFlag,
          onClick: () => !disabledFlag && buttonConfig.click(props),
        };
        buttons.push(h(DolIconButton, buttonProps));
      });

      // , type: 'primary', ghost: true
      const moreButton = h(DolButton, {icon: 'MoreOutlined', shape: 'circle', size: 'small'});
      const menuItems = [];
      renderButtons.slice(this.maxCount - 1).forEach(buttonConfig => {
        const menuItemContent = () => h(Space, {}, () => [h(DolIcon, {type: buttonConfig.icon}), buttonConfig.title]);
        menuItems.push(h(MenuItem, {onClick: () => buttonConfig.click(props)}, menuItemContent));
      });
      const dropdownOverlay = h(Menu, () => menuItems);
      buttons.push(h(Dropdown, {}, {
        overlay: () => dropdownOverlay,
        default: () => moreButton,
      }));
    }

    return h(Space, {class: 'dol-list-button', size: 14}, () => buttons);
  },
};
</script>

<style lang="scss">
.dol-list-button{
}
</style>
